import { PostRequest } from "../service"

export const uploadFile = (file) => {
    return PostRequest("upload", file)
}